/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { allIndividualClients } from "../../../data/Axios/queries";
import { clientManagementUrl } from "../../../config";
import IndividualClientsForm from "./form";
import { IndividualClientsColumns } from "../../../data/DynamicTable/Collumns";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { UploadDocumentComponent } from "../../../data/DynamicTable/Modal";
import { downloadIndividualClientFile } from "../../../data/DynamicTable/DynamicFunctions";
import { CloudUpload } from "@mui/icons-material";
const base_url = clientManagementUrl.uri;
const actions = {
  entity: "Individual Clients",
  required: "id",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "individualClientIds",
    inputObjectName: "bulkActivateDeactivateIndividualClients",
  },
  ViewIndividualClientCases: {
    key: "ViewCases",
    button_name: " Files 360",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
   EngagementLetter: {
    key: "EngagementLetter",
    button_name: " Engagement Letter",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
   viewJournalEntries: { // New action for journal entries
    key: "VIEW_JOURNAL_ENTRIES",
    button_name: "View Journal Entries",
   Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    query: "anyIndividualJournalLinesByColumnValues", // Query to fetch journal entries
    inputFields: (row) => ({ 
      identifierId: row.id,
      cancelled: null,
    }),
    returnFields: [
      "journalLineID",
      "journalEntryID",
      "accountID",
      "debit",
      "credit",
      "description",
      "createdDate",
      "caseId",
      "applicationId",
      "applicationType",
    ],
  },

  dataObject: {
    inputFields: {
      isActive: null,
    },
    inputObjectName: "allIndividualClients",
    inputSubObjectName: "clientModel",
    returnFields: [
      "id",
      "firstName",
      "lastName",
      "dateOfBirth",
      "genderId",
      "gender",
      "nationality",
      "identificationType",
      "identificationNumber",
      "contactNumber",
      "email",
      "address",
      "occupation",
      "employer",
      "emergencyContactName",
      "emergencyContactNumber",
      "relationshipWithEmergencyContact",
      "dateAdded",
      "notes",
      "accountBalance",
      "isActive",
      "statusFlag",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
      "companyId",
      "regionId",
      "branchId",
      "company",
    ],
  },
};
function IndividualClients() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };
  const handleDownload = async () => {
    await downloadIndividualClientFile();
  };
  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Individual Client(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTable
        title="Individual Clients"
        subtitle="View all Individual Clients, create edit or view details"
        columns={IndividualClientsColumns}
        FormComponent={IndividualClientsForm}
        //query={allIndividualClients}
        base_url={base_url}
        actions={actions}
        entity={"Individual Clients"}
      />
      <UploadDocumentComponent
        uploadType="individualClient"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
}

export default IndividualClients;
